/** Referências da consulta da Curva ABC de Vendas */
export interface CurvaAbcVendaReferencia {
    id: number;
    nome: string;
}

export const referenciaPedido: CurvaAbcVendaReferencia = {id: 1, nome: 'Pedidos'};
export const referenciaNotaFiscal: CurvaAbcVendaReferencia = {id: 2, nome: 'Notas Fiscais'};

export const referencias: CurvaAbcVendaReferencia[] = [
    referenciaPedido,
    referenciaNotaFiscal
];

/** Verifica se a referência é pedido  */
export function isReferenciaPedido(referencia: number): boolean {
    return referencia === referenciaPedido.id;
}

/** Verifica se a referência é nota fiscal */
export function isReferenciaNotaFiscal(referencia: number): boolean {
    return referencia === referenciaNotaFiscal.id;
}
